import { Adapter as e } from "../../../../../adapter.js";
import { ShopTicketModel as o } from "./shopTicket.model.js";
class l extends e {
  adapt(r) {
    return new o({
      validationErrors: (r == null ? void 0 : r.validation_errors) ?? [],
      ...r
    });
  }
  serialize(r) {
  }
}
export {
  l as ShopTicketAdapter
};
//# sourceMappingURL=shopTicket.adapter.js.map
